import { writable } from "svelte/store";
export function getNextActiveIndex(list, activeIndex, shouldGetNext) {
    const listLength = list.length;
    let index = activeIndex;
    if (listLength === 0) {
        return -1;
    }
    index += shouldGetNext ? 1 : -1;
    index = (index + listLength) % listLength;
    return Math.max(0, Math.min(index, listLength - 1));
}
const TRANSITION_END = "transitionend";
const MILLISECONDS_MULTIPLIER = 1000;
const getTransitionDurationFromElement = (element) => {
    if (!element) {
        return 0;
    }
    // Get transition-duration of the element
    let { transitionDuration, transitionDelay } = window.getComputedStyle(element);
    const floatTransitionDuration = Number.parseFloat(transitionDuration);
    const floatTransitionDelay = Number.parseFloat(transitionDelay);
    // Return 0 if element or transition duration is not found
    if (!floatTransitionDuration && !floatTransitionDelay) {
        return 0;
    }
    // If multiple durations are defined, take the first
    transitionDuration = transitionDuration.split(",")[0];
    transitionDelay = transitionDelay.split(",")[0];
    return (Number.parseFloat(transitionDuration) + Number.parseFloat(transitionDelay)) * MILLISECONDS_MULTIPLIER;
};
const triggerTransitionEnd = (element) => {
    element.dispatchEvent(new Event(TRANSITION_END));
};
export const executeAfterTransition = (callback, transitionElement, waitForTransition = true) => {
    if (!waitForTransition) {
        callback();
        return;
    }
    const durationPadding = 5;
    const emulatedDuration = getTransitionDurationFromElement(transitionElement) + durationPadding;
    let called = false;
    const handler = ({ target }) => {
        if (target !== transitionElement) {
            return;
        }
        called = true;
        transitionElement.removeEventListener(TRANSITION_END, handler);
        callback();
    };
    transitionElement.addEventListener(TRANSITION_END, handler);
    setTimeout(() => {
        if (!called) {
            triggerTransitionEnd(transitionElement);
        }
    }, emulatedDuration);
};
export const reflow = (element) => {
    element.offsetHeight;
};
/**
 * Control the join waitlist form, it should be in the same state
 * among slides.
 */
export let isWaitlistSubmitted = writable(false);
export function setWaitlistSubmitted(value) {
    isWaitlistSubmitted.set(value);
}
